import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Virginia = () => {
  return (
    <StatePropertyTaxPage
      stateName="Virginia"
      processDescription="Property owners may appeal their assessment by filing with the local board of equalization within 30 days of notice, or with the Virginia Department of Taxation. Appeals should include evidence supporting the property owner's claimed fair market value."
      noticeOfValueMailed="April"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in April following annual assessments or reassessments."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Virginia assesses property as of January 1 each year. This assessment date ensures consistent property valuations across all counties and cities in Virginia."
      deadlineExplanation="Property owners have 30 days from notice to file appeals with the local board of equalization. This typically results in a May deadline."
    />
  );
};

export default Virginia;